// Sweet Temptation: independent navigation slot controls the existing Horizon slideshow.
document.addEventListener('click', (event) => {
  const button = event.target.closest('.cravynox-sweet-independent-nav [data-sweet-index]');
  if (!button) return;
  const section = button.closest('.cravynox-sweet-temptation');
  const index = Number(button.dataset.sweetIndex);
  const nativeButtons = section?.querySelectorAll('media-gallery slideshow-controls[thumbnails] .slideshow-controls__thumbnail');
  if (!nativeButtons?.[index]) return;
  nativeButtons[index].click();
  section.querySelectorAll('.cravynox-sweet-nav-button').forEach((b) => {
    if (b === button) b.setAttribute('aria-current', 'true');
    else b.removeAttribute('aria-current');
  });
});
